import React, { useState } from 'react';
import styles from '../../styles/Header.module.css';
import logo from '../../../public/i/eDoc.svg';
import { Support } from '../../../public/icons';
import Contacts from '../Contacts';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

function Navbar({ onSupportClick }) {
  return (
    <nav>
      <ul className={styles.navlist}>
        <li>
          <button
            type="button"
            className={styles.icon}
            onClick={onSupportClick}
          >
            <Support color="var(--white)" height="27px" width="27px" />
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default function Header() {
  const [supportMenu, setSupportMenu] = useState(false);

  const onSupportClick = () => {
    setSupportMenu(!supportMenu);
  };

  document.addEventListener('click', function({ target }) {
    const headerPopup = document.getElementById('headerPopup');
    const modalWrapper = document.getElementById('modalWrapper');
    const isClickInsidePopup = headerPopup?.contains(target);
    const isClickInsideModal = modalWrapper?.contains(target);

    if (!isClickInsidePopup && isClickInsideModal) {
      setSupportMenu(false);
    }
  });

  return (
    <header className={`${styles.headerPub} ${styles.line}`}>
      <Link to="/" className={styles.logo} reloadDocument={true}>
        <img src={logo} alt="" />
      </Link>
      <Navbar
        onSupportClick={onSupportClick}
      />
      {(supportMenu) && (
        <div className={styles.modalWrapper} id="modalWrapper">
          <div className={styles.headerPopup} id="headerPopup">
            {supportMenu && <Contacts />}
          </div>
        </div>
      )}
    </header>
  );
}

Navbar.propTypes = {
  onSupportClick: PropTypes.func.isRequired,
};
